import React from "react";
import { Box, SxProps, Theme } from "@mui/material";

type PageContainerProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

// Standard content width for pages with sparse content, so they don't
// stretch edge-to-edge on wide screens and stay readable. Reuse this
// wherever a page should look centered with even whitespace on both sides.
const PageContainer: React.FC<PageContainerProps> = ({ children, sx }) => (
  <Box sx={{ maxWidth: 1100, width: "100%", mx: "auto", ...sx }}>
    {children}
  </Box>
);

export default PageContainer;
